import { createFileRoute } from '@tanstack/react-router';
import { AutomaticModeCard } from '@/features/review/mode-card';
import { ConnectionsPage } from '@/features/settings/connections/connections-page';

// S21 · Connessioni, with the owner's «Modalità automatica» on top (ADR 0086).
export const Route = createFileRoute('/_app/settings/')({
  component: SettingsIndex,
});

function SettingsIndex() {
  return (
    <>
      <AutomaticModeCard />
      <ConnectionsPage />
    </>
  );
}
